'ViewPOReceipts'.list()
'View Receipts'.title()
'POReceipt'.datatype()
'Back'.action({act: 'cancel'})
'Refresh'.action({act: "refresh"})
'receiptNumber'.field()
'receivedDate'.field()
'supplier'.field({showAsLink: true})
'Edit'.action({place: 'row', act: 'edit'});
'Trash'.action({place: 'row', act: 'trash'});
'POReceiptMaint.js'.maintSpecname()

'ViewPOReceipts'.dynamicTitle(function() {
  let po = this.callerCast(); if ( ! po ) return
  if ( po.datatype() !== "PO" ) return 
  let res = "View Receipts for Purchase Order " + po.purchaseOrderNumber
  return res
})

'ViewPOReceipts'.criteria(async function () {
  let r = this.callerCast(); if ( ! r ) return null
  if ( r.datatype() !== "PO" ) return null
  let res = {parentId: r.id}
  return res
})

